import { DEFAULT_RELATIVE_PAST_DATE_OPTIONS } from 'components/Common/DateRangeFilter/constants';
import { calculateDateTimeForRelativeDate } from 'components/Common/DateRangeFilter/utils';
import { FILTER_SETS } from 'components/Common/VerticalFilterV2/constants';

import {
  DEFAULT_DATE_RANGE,
  DEFAULT_PAST_DATE_RANGE,
} from 'modules/EventSchedulerV2/constants';
import {
  SET_SHOW_DISTRICTS_WITHOUT_EVENTS,
  UPDATE_EVENT_OPENINGS_SHARED_FILTERS,
  UPDATE_ALL_DISTRICTS_EVENTS_FILTERS,
  UPDATE_HOST_EVENTS_FILTERS,
  UPDATE_K12_ADMIN_EVENTS_FILTERS,
} from 'modules/EventSchedulerV2/store/actionTypes';

const { startDate, endDate } = calculateDateTimeForRelativeDate({
  relativeDateId: DEFAULT_DATE_RANGE,
});

const { startDate: pastStartDate, endDate: pastEndDate } =
  calculateDateTimeForRelativeDate({
    relativeDateId: DEFAULT_PAST_DATE_RANGE,
    relativeDateOptions: DEFAULT_RELATIVE_PAST_DATE_OPTIONS,
  });

const K12_ADMIN_EVENTS_INITIAL_STATE = {
  [FILTER_SETS.SCHEDULED_EVENTS]: {
    startDate,
    endDate,
    showOnlyMyEvents: true,
  },
  [FILTER_SETS.PARTNER_EVENTS]: { startDate, endDate },
  [FILTER_SETS.PAST_EVENTS]: { startDate: pastStartDate, endDate: pastEndDate },
};

/** Default date range filter will be ALL_TIME, since startDate and endDate is null for both the eventOpenings and hostEvents */
const MEMBER_EVENTS_INITIAL_STATE = {
  eventOpenings: {
    sharedFilters: {
      startDate: null,
      endDate: null,
      format: [],
      location: [],
    },
    allDistrictsEventsFilters: {
      state: [],
      radius: null,
      address: null, // it represents the location object which contains zipCode as well
    },
    showDistrictsWithoutEvents: false,
  },
  hostEvents: {
    startDate: null,
    endDate: null,
    format: [],
    location: [],
  },
};

const initialState = {
  member: MEMBER_EVENTS_INITIAL_STATE,
  k12Admin: K12_ADMIN_EVENTS_INITIAL_STATE,
};

const eventSchedulerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_ALL_DISTRICTS_EVENTS_FILTERS: {
      return {
        ...state,
        member: {
          ...state.member,
          eventOpenings: {
            ...state.member.eventOpenings,
            allDistrictsEventsFilters: {
              ...state.member.eventOpenings.allDistrictsEventsFilters,
              ...payload,
            },
          },
        },
      };
    }
    case UPDATE_EVENT_OPENINGS_SHARED_FILTERS: {
      return {
        ...state,
        member: {
          ...state.member,
          eventOpenings: {
            ...state.member.eventOpenings,
            sharedFilters: {
              ...state.member.eventOpenings.sharedFilters,
              ...payload,
            },
          },
        },
      };
    }
    case SET_SHOW_DISTRICTS_WITHOUT_EVENTS: {
      return {
        ...state,
        member: {
          ...state.member,
          eventOpenings: {
            ...state.member.eventOpenings,
            showDistrictsWithoutEvents: payload,
          },
        },
      };
    }
    case UPDATE_HOST_EVENTS_FILTERS: {
      return {
        ...state,
        member: {
          ...state.member,
          hostEvents: {
            ...state.member.hostEvents,
            ...payload,
          },
        },
      };
    }
    case UPDATE_K12_ADMIN_EVENTS_FILTERS:
      return {
        ...state,
        k12Admin: {
          ...state.k12Admin,
          [payload.filterStateKey]: {
            ...state.k12Admin[payload.filterStateKey],
            ...payload.value,
          },
        },
      };
    default:
      return state;
  }
};

export default eventSchedulerReducer;
